import { Dialog } from '@mui/material'
import { useEffect, useState } from 'react'
import EventsEngine from '../../../engines/EventsEngine'
import ErrorBoundary from '../../error_boundary/ErrorBoundary'
import SpotlightError from '../../error_boundary/error_pages/SpotlightError'
import Spotlight from './Spotlight'

function SpotlightModal() {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const onShortcut = (e: KeyboardEvent) => {
            if (e.key === 'k' && e.metaKey) {
                e.preventDefault()
                setOpen(v => !v)
            }
        }

        const unsub = EventsEngine.subscribe('open-spotlight', 'Spotlight', () => {
            setOpen(true)
        })

        const unsub1 = EventsEngine.subscribe('close-spotlight', 'Spotlight', () => {
            onClose()
        })

        document.addEventListener('keydown', onShortcut)
        return () => {
            document.removeEventListener('keydown', onShortcut)
            unsub()
            unsub1()
        }
    }, [])

    const onClose = () => {
        setOpen(false)
    }

    return (
        <Dialog className='spotlight-modal' fullWidth={true} open={open} onClose={onClose}>
            <ErrorBoundary renderError={e => <SpotlightError error={e} />}>
                <Spotlight />
            </ErrorBoundary>
        </Dialog>
    )
}

export default SpotlightModal
